import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import usePopOver from "@/hooks/use-popover";
import IVariation from "@/interfaces/variation.interface";
import { VariationsTableMessages } from "@/messages/variation/variations-table.messages";

import { VariationPopover } from "../VariationPopover";

interface Props {
  variation: IVariation;
  index: number;
  messages: VariationsTableMessages;
}

export function Row({ variation, index, messages }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<IVariation>();

  return (
    <TableRow index={index}>
      <TableCell style={{ width: "90%" }}>{variation.description}</TableCell>
      <TableCell style={{ width: "20%" }}>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            openPopover(e, variation);
          }}
        >
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <VariationPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
